import { store } from 'react-notifications-component';
import LocalStrings from '../../../assets/languages';

export const showSuccess = (message, title = null) => {
  let toastPayload = {
    message: message ?? LocalStrings.dynamic.kCongratulations,
    type: 'success',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  };

  if (title) toastPayload.title = title;

  store.addNotification(toastPayload);
};

export const showError = (message, title = null) => {
  let toastPayload = {
    message: message ?? LocalStrings.dynamic.kSomethingWentWrongMsg,
    type: 'danger',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  };

  if (title) toastPayload.title = title;

  store.addNotification(toastPayload);
};

export const showWarning = (message, title = null) => {
  let toastPayload = {
    message: message ?? LocalStrings.dynamic.kConfirm,
    type: 'warning',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true
    }
  };

  if (title) toastPayload.title = title;

  store.addNotification(toastPayload);
};

export const showToast = (message, title = null) => {
  let toastPayload = {
    message: message ?? LocalStrings.dynamic.kCongratulations,
    type: 'default',
    insert: 'top',
    container: 'top-center',
    dismiss: {
      duration: 3000,
      onScreen: true,
      click: true,
      pauseOnHover: true,
      showIcon: true
    }
  };

  if (title) toastPayload.title = title;

  store.addNotification(toastPayload);
};

export const showCustomInfo = (message, title = null) => {
  let toastPayload = {
    message: message ?? LocalStrings.dynamic.kCongratulations,
    type: 'default',
    insert: 'top',
    container: 'top-right',
    dismiss: {
      duration: 2000
    }
  };

  if (title) toastPayload.title = title;

  store.addNotification(toastPayload);
};

export const showNoInternet = () => {
  let toastPayload = {
    type: 'danger',
    container: 'bottom-full',
    title: LocalStrings.dynamic.kNoInternet,
    message: LocalStrings.dynamic.kNoInternetMsg,
    animationIn: ['animate__animated animate__fadeIn'],
    animationOut: ['animate__animated animate__fadeOut']
  };

  const id = store.addNotification(toastPayload);
  return id;
};
